import React from "react";

const DeepSeekStatCards = ({ stats, t }) => {
    // Percentage of Start From Topic
    const startFromTopicTotal = (stats?.StartFromTopicCount || 0) + (stats?.NotStartFromTopicCount || 0);
    const startFromTopicPct = startFromTopicTotal > 0 ? ((stats.StartFromTopicCount / startFromTopicTotal) * 100).toFixed(1) : "0.0";
    const directQuestionPct = startFromTopicTotal > 0 ? ((stats.NotStartFromTopicCount / startFromTopicTotal) * 100).toFixed(1) : "0.0";

    // Percentage of Cash vs Live
    const fromCashTotal = (stats?.FromCashCount || 0) + (stats?.NotFromCashCount || 0);
    const fromCashPct = fromCashTotal > 0 ? ((stats.FromCashCount / fromCashTotal) * 100).toFixed(1) : "0.0";
    const liveAnswerPct = fromCashTotal > 0 ? ((stats.NotFromCashCount / fromCashTotal) * 100).toFixed(1) : "0.0";

    return (
        <>
            {/* Current Month Statistics */}
            <div className="deepseek-stats-section-title">
                {t('Pages.DeepSeekAdmin.usageStats') || "إحصائيات استهلاك المنصة"} - {t('range.ThisMonth') || "هذا الشهر"}
            </div>
            <div className="deepseek-stats-grid triple">
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.monthlySpent') || "استهلاك الشهر الحالي"}</h6>
                        <i className="fal fa-dollar-sign text-danger" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-danger">
                        ${stats ? stats.MonthlyCost.toFixed(4) : "0.0000"}
                    </div>
                </div>
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.monthlyChats') || "محادثات الشهر الحالي"}</h6>
                        <i className="fal fa-comments text-primary" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-primary">
                        {stats ? stats.MonthlyChats : 0}
                    </div>
                </div>
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.monthlyMessages') || "رسائل الشهر الحالي"}</h6>
                        <i className="fal fa-comment-alt-lines text-info" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-info">
                        {stats ? stats.MonthlyMessages : 0}
                    </div>
                </div>
            </div>

            {/* Cumulative General Statistics */}
            <div className="deepseek-stats-section-title">
                {t('Pages.DeepSeekAdmin.allStats') || "مؤشرات الاستهلاك العامة"} - {t('Pages.DeepSeekAdmin.totalBalance') || "الرصيد التراكمي"}
            </div>
            <div className="deepseek-stats-grid">
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.totalSpent') || "إجمالي التكلفة"}</h6>
                        <i className="fal fa-usd-square text-danger" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-danger">
                        ${stats ? stats.TotalCost.toFixed(4) : "0.0000"}
                    </div>
                </div>
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.totalChats') || "إجمالي المحادثات"}</h6>
                        <i className="fal fa-comments text-primary" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-primary">
                        {stats ? stats.TotalChats : 0}
                    </div>
                </div>
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.totalMessages') || "إجمالي الرسائل المولدة"}</h6>
                        <i className="fal fa-comment-alt-lines text-info" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-info">
                        {stats ? stats.TotalMessages : 0}
                    </div>
                </div>
                <div className="deepseek-stat-box token-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.unsupportedChats') || "المحادثات غير المدعومة (خارج النطاق)"}</h6>
                        <i className="fal fa-exclamation-triangle text-warning" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-warning" style={{ fontSize: '20px', marginBottom: '8px' }}>
                        {stats ? stats.UnsupportedChats : 0}
                    </div>
                    <div className="deepseek-token-details">
                        <div className="d-flex justify-content-between">
                            <span>{t('Pages.DeepSeekAdmin.unsupportedChatsMonthly') || "محادثات الشهر غير المدعومة"}:</span>
                            <strong>{stats ? stats.UnsupportedChatsMonthly : 0}</strong>
                        </div>
                        <div className="d-flex justify-content-between">
                            <span>{t('Pages.DeepSeekAdmin.unsupportedChatsCost') || "تكلفة المحادثات غير المدعومة"}:</span>
                            <strong>${stats ? stats.UnsupportedChatsCost.toFixed(4) : "0.0000"}</strong>
                        </div>
                    </div>
                </div>
            </div>

            {/* Conversations Start Method */}
            <div className="deepseek-stats-section-title">
                {t('Pages.DeepSeekAdmin.startMethodTitle') || "طرق بدء المحادثات (اقتراح موضوع vs سؤال مباشر)"}
            </div>
            <div className="deepseek-stats-grid">
                <div className="deepseek-stat-box start-method-card">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center gap-2">
                            <i className="fal fa-lightbulb text-success ml-2" style={{ fontSize: '16px' }}></i>
                            <h6 className="m-0">{t('Pages.DeepSeekAdmin.startFromTopic') || "محادثات بدأت من اقتراح موضوع"}</h6>
                        </div>
                        <span className="badge bg-soft-success text-success pct-badge">{startFromTopicPct}%</span>
                    </div>
                    <div className="value text-success">
                        {stats ? stats.StartFromTopicCount : 0}
                    </div>
                </div>
                <div className="deepseek-stat-box start-method-card">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center gap-2">
                            <i className="fal fa-question-circle text-secondary ml-2" style={{ fontSize: '16px' }}></i>
                            <h6 className="m-0">{t('Pages.DeepSeekAdmin.startDirect') || "محادثات بدأت من سؤال مباشر"}</h6>
                        </div>
                        <span className="badge bg-soft-secondary text-secondary pct-badge">{directQuestionPct}%</span>
                    </div>
                    <div className="value text-secondary">
                        {stats ? stats.NotStartFromTopicCount : 0}
                    </div>
                </div>
            </div>

            {/* Conversations Response Source (Cached vs Live) */}
            <div className="deepseek-stats-section-title">
                {t('Pages.DeepSeekAdmin.responseSourceTitle') || "مصدر ردود المحادثات (الكاش vs البث الحي)"}
            </div>
            <div className="deepseek-stats-grid">
                <div className="deepseek-stat-box start-method-card">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center gap-2">
                            <i className="fal fa-bolt text-info ml-2" style={{ fontSize: '16px' }}></i>
                            <h6 className="m-0">{t('Pages.DeepSeekAdmin.fromCash') || "إجابات مسترجعة من الكاش (وفرت تكلفة)"}</h6>
                        </div>
                        <span className="badge bg-soft-info text-info pct-badge">{fromCashPct}%</span>
                    </div>
                    <div className="value text-info">
                        {stats ? stats.FromCashCount : 0}
                    </div>
                </div>
                <div className="deepseek-stat-box start-method-card">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center gap-2">
                            <i className="fal fa-broadcast-tower text-primary ml-2" style={{ fontSize: '16px' }}></i>
                            <h6 className="m-0">{t('Pages.DeepSeekAdmin.notFromCash') || "إجابات مولدة حية من النموذج"}</h6>
                        </div>
                        <span className="badge bg-soft-primary text-primary pct-badge">{liveAnswerPct}%</span>
                    </div>
                    <div className="value text-primary">
                        {stats ? stats.NotFromCashCount : 0}
                    </div>
                </div>
            </div>

            {/* Tokens Consumption & Volume */}
            <div className="deepseek-stats-section-title">
                {t('Pages.DeepSeekAdmin.tokensStatsTitle') || "مؤشرات حجم استهلاك الرموز (Tokens)"}
            </div>
            <div className="deepseek-stats-grid">
                <div className="deepseek-stat-box token-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.monthlyTokens') || "رموز الشهر الحالي"}</h6>
                        <i className="fal fa-coins text-success" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-success" style={{ fontSize: '20px', marginBottom: '8px' }}>
                        {stats ? (stats.MonthlyPromptTokens + stats.MonthlyCompletionTokens).toLocaleString() : 0}
                    </div>
                    <div className="deepseek-token-details">
                        <div className="d-flex justify-content-between">
                            <span>{t('Pages.DeepSeekAdmin.promptTokens') || "الاستعلام"}:</span>
                            <strong>{stats ? stats.MonthlyPromptTokens.toLocaleString() : 0}</strong>
                        </div>
                        <div className="d-flex justify-content-between">
                            <span>{t('Pages.DeepSeekAdmin.completionTokens') || "الإجابة"}:</span>
                            <strong>{stats ? stats.MonthlyCompletionTokens.toLocaleString() : 0}</strong>
                        </div>
                    </div>
                </div>
                <div className="deepseek-stat-box token-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.totalTokens') || "إجمالي الرموز"}</h6>
                        <i className="fal fa-database text-warning" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-success" style={{ fontSize: '20px', marginBottom: '8px' }}>
                        {stats ? (stats.TotalPromptTokens + stats.TotalCompletionTokens).toLocaleString() : 0}
                    </div>
                    <div className="deepseek-token-details">
                        <div className="d-flex justify-content-between">
                            <span>{t('Pages.DeepSeekAdmin.promptTokens') || "الاستعلام"}:</span>
                            <strong>{stats ? stats.TotalPromptTokens.toLocaleString() : 0}</strong>
                        </div>
                        <div className="d-flex justify-content-between">
                            <span>{t('Pages.DeepSeekAdmin.completionTokens') || "الإجابة"}:</span>
                            <strong>{stats ? stats.TotalCompletionTokens.toLocaleString() : 0}</strong>
                        </div>
                    </div>
                </div>
            </div>

            {/* Performance and Latency Statistics */}
            <div className="deepseek-stats-section-title">
                {t('Pages.DeepSeekAdmin.performanceStatsTitle') || "مؤشرات سرعة الأداء والاستجابة"}
            </div>
            <div className="deepseek-stats-grid triple">
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.averageAITime') || "متوسط زمن استجابة الذكاء الاصطناعي"}</h6>
                        <i className="fal fa-hourglass-start text-primary" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-primary">
                        {stats ? stats.AverageAITime : "0.00"}<span className="small text-muted mr-1" style={{ fontSize: '12px' }}>{t('Pages.DeepSeekAdmin.seconds') || "ثانية"}</span>
                    </div>
                </div>
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.averageStreamStartTime') || "متوسط زمن بدء بث الإجابة"}</h6>
                        <i className="fal fa-stream text-info" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-info">
                        {stats ? stats.AverageStreamStartTime : "0.00"}<span className="small text-muted mr-1" style={{ fontSize: '12px' }}>{t('Pages.DeepSeekAdmin.seconds') || "ثانية"}</span>
                    </div>
                </div>
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.averageDBTime') || "متوسط زمن استعلام قاعدة البيانات"}</h6>
                        <i className="fal fa-database text-success" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-success">
                        {stats ? stats.AverageDBTime : "0.00"}<span className="small text-muted mr-1" style={{ fontSize: '12px' }}>{t('Pages.DeepSeekAdmin.seconds') || "ثانية"}</span>
                    </div>
                </div>
            </div>

            {/* Provider Breakdown Statistics */}
            <div className="deepseek-stats-section-title">
                <i className="fal fa-server ml-2 text-secondary" style={{ fontSize: '18px' }}></i>
                {t('Pages.DeepSeekAdmin.agent') || "النموذج"} - {t('Pages.DeepSeekAdmin.agentFilter') || "الاستهلاك حسب النموذج"}
            </div>
            <div className="deepseek-stats-grid mb-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.Chatbot.ModelDeepSeek') || "DeepSeek Flash"} ({t('Pages.DeepSeekAdmin.requestsCount', { count: stats ? stats.DeepSeekChats : 0 })})</h6>
                        <i className="fal fa-brain text-primary" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-primary" style={{ fontSize: '20px' }}>
                        ${stats ? stats.DeepSeekCost.toFixed(4) : "0.0000"}
                    </div>
                </div>
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.Chatbot.ModelDeepSeekPro')} ({t('Pages.DeepSeekAdmin.requestsCount', { count: stats ? stats.DeepSeekProChats : 0 })})</h6>
                        <i className="fal fa-robot" style={{ fontSize: '18px', color: '#701a75' }}></i>
                    </div>
                    <div className="value" style={{ fontSize: '20px', color: '#701a75' }}>
                        ${stats ? stats.DeepSeekProCost.toFixed(4) : "0.0000"}
                    </div>
                </div>
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.Chatbot.ModelGemini') || "Gemini Flash LITE"} ({t('Pages.DeepSeekAdmin.requestsCount', { count: stats ? stats.OtherChats : 0 })})</h6>
                        <i className="fal fa-sparkles text-info" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-info" style={{ fontSize: '20px' }}>
                        ${stats ? stats.OtherCost.toFixed(4) : "0.0000"}
                    </div>
                </div>
                <div className="deepseek-stat-box">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6>{t('Pages.DeepSeekAdmin.averageChatCost') || "متوسط تكلفة المحادثة"}</h6>
                        <i className="fal fa-chart-line text-success" style={{ fontSize: '18px' }}></i>
                    </div>
                    <div className="value text-success" style={{ fontSize: '20px' }}>
                        ${stats && stats.TotalChats > 0 ? (stats.TotalCost / stats.TotalChats).toFixed(5) : "0.00000"}
                    </div>
                </div>
            </div>
        </>
    );
};

export default DeepSeekStatCards;
